import { useMemo } from "react";
import classnames from "classnames";
import CardArtwork from "@/components/Card/CardArtwork";
import { ButtonLink } from "@/components/Buttons/index";
import styles from "@/styles/Row.module.scss";
import VersatileLink from "@/components/VersatileLink";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function AdvertjPickupListRow(_ref) {
  let {
    item
  } = _ref;
  const target = useMemo(() => {
    if (item.targetBlank) {
      return "_blank";
    } else {
      return "_self";
    }
  }, [item]);
  return /*#__PURE__*/_jsx("div", {
    className: classnames(styles.container, styles.pickup),
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.inner,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.artwork,
        children: /*#__PURE__*/_jsx(CardArtwork, {
          item: item,
          className: styles.artworkInner,
          href: item.url,
          linkAttr: {
            target,
            rel: "noopener noreferrer"
          }
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.info,
        children: [/*#__PURE__*/_jsx("h4", {
          className: styles.title,
          children: /*#__PURE__*/_jsx(VersatileLink, {
            href: item.url,
            children: /*#__PURE__*/_jsx("a", {
              target: target,
              rel: "noopener noreferrer",
              children: item.name
            })
          })
        }), /*#__PURE__*/_jsx("p", {
          className: styles.description,
          children: item.description
        }), /*#__PURE__*/_jsx("div", {
          className: styles.buttons,
          children: /*#__PURE__*/_jsx(ButtonLink, {
            fillColor: true,
            medium: true,
            href: item.url,
            atagProps: {
              target,
              rel: "noreferrer noopener"
            },
            children: "\u8A73\u7D30\u3092\u898B\u308B"
          })
        })]
      })]
    })
  });
}